import { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { FileFilterProvider } from '@/contexts/fileFilter.tsx'
import { ShareDriveViewProvider } from '@/contexts/shareDriveViewProvider.tsx'
import { useDriveViewContext } from '@/contexts/driveViewContext.tsx'
import DriveViewer from '@/components/DriveViewer.tsx'
import { StatScopeProvider } from '@/contexts/statsScopeContext.tsx'
import { HeyDriveType } from '@/models/drive.ts'

export function SharedPage() {
  return (
    <FileFilterProvider>
      <ShareDriveViewProvider>
        <SharedPageAutoNavigate />
      </ShareDriveViewProvider>
    </FileFilterProvider>
  )
}

// Auto-navigate to first album when none is selected
function SharedPageAutoNavigate() {
  const { albums, metadata } = useDriveViewContext()
  const { shareId, shareAlbumId } = useParams<{ shareId: string, shareAlbumId?: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    if (albums.length > 0 && !shareAlbumId) {
      navigate(`/s/${shareId}/${albums[0].id}`, { replace: true })
    }
  }, [albums, shareAlbumId, shareId, navigate])

  // Shares exist on B2C drives too; only prof content is tracked.
  const isTracked = metadata?.driveType === HeyDriveType.PROF
  const statScope = useMemo(
    () => ({ source: 'share' as const, share: isTracked ? shareId : undefined }),
    [isTracked, shareId],
  )

  return (
    <StatScopeProvider scope={statScope}>
      <DriveViewer />
    </StatScopeProvider>
  )
}
